export const literalsOverrides: Record<string, Record<string, string>> = {
  'app.mantra-project.eu': {
    create_account_for_application_label: 'Please create an account to fill in the survey',
    application_apply_now: 'Fill in the survey',
    application_fill_your_application: 'Fill in the survey',
    application_deadline_label: 'Survey deadline',
  },
};

export const overrideTranslation = (translationId: string) => {
  const hostname = window.location.hostname;
  const literalsForHostname = literalsOverrides[hostname];

  if (!literalsForHostname) {
    return null;
  }

  return literalsForHostname[translationId];
};
